import styled from 'styled-components'

interface IStatusCardLegacyContentLeftStyledProps {}

export const StatusCardLegacyContentLeftStyled = styled.div<IStatusCardLegacyContentLeftStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  flex-shrink: 1;

  min-width: 15%;
`
